/*
 * @Description: 首页入口
 * @Author: fxg
 * @Date: 2020-07-01 14:36:58
 * @LastEditors: 刘小二
 * @LastEditTime: 2025-12-24 16:35:12
 */
import request from '@/utils/request'

// 获取数据字典
export function saveOrUpdate(data) {
  return request({
    url: '/base/system/index/page/save_or_update',
    method: 'post',
    data
  })
}
export function getInfo(params) {
  return request({
    url: '/base/system/index/page/get_info',
    method: 'get',
    params
  })
}
/**获取通知公告*/
export function indexquery_page(data) {
  return request({
    url: '/base/system/notice/index/query_page',
    method: 'post',
    data
  })
}
/**获取流程任务*/
export function backlogQueryByReceiptNumber(data) {
  return request({
    url: `/workflow/system/sign/task/center/backlogQueryByReceiptNumber?receiptNumber=${data}`,
    method: 'get',
  })
}
/**获取待办任务*/
export function backlogQueryPage(data) {
  return request({
    url: '/workflow/system/sign/task/center/backlogQueryPage',
    method: 'post',
    data
  })
}
/**获取跟踪事项*/
export function tailAfterTaskQueryPage(data) {
  return request({
    url: '/workflow/system/sign/task/center/tailAfterTaskQueryPage',
    method: 'post',
    data
  })
}

/**获取已办任务*/
export function finishedTaskQueryPage(data) {
  return request({
    url: '/workflow/system/sign/task/center/finishedTaskQueryPage',
    method: 'post',
    data
  })
}

/**获取本人发起任务*/
export function myOutTaskQueryPage(data) {
  return request({
    url: '/workflow/system/sign/task/center/myOutTaskQueryPage',
    method: 'post',
    data
  })
}

/**获取收藏任务*/
export function collectQueryPage(data) {
  return request({
    url: '/workflow/system/sign/task/center/collectQueryPage',
    method: 'post',
    data
  })
}

/**获取试验人*/
export function getUsetListByPermission(params) {
    return request({
      url: '/base/system/user/getUsetListByPermission',
      method: 'get',
      params
    })
  }

  /**获取快检获取检测项目*/
export function getDetailTesItems(params) {
    return request({
      url: '/icps/system/sign/intelligent/detectionValue/getDetailTesItems',
      method: 'get',
      params
    })
  }

   /**获取检验结果*/
export function countResult(data) {
    return request({
      url: '/icps/system/sign/intelligent/detectionValue/countResult',
      method: 'post',
      data
    })
  }


/**保存检验结果*/
export function saveResul(data) {
    return request({
        url: '/icps/system/sign/intelligent/detectionValue/saveResult',
        method: 'post',
        data
    })
}

/**临时保存检验结果*/
export function saveOrupdate(data) {
    return request({
        url: '/icps/system/sign/intelligent/detectionValue/saveOrupdate',
        method: 'post',
        data
    })
}

/**非快检获取默认检测数据*/
export function getDefaultData(params) {
    return request({
        url: '/icps/system/sign/intelligent/detectionValue/getDefaultData',
        method: 'get',
        params
    })
}

/**非快检获取保存的检测数据*/
export function getDetail(data) {
    return request({
        url: '/icps/system/sign/intelligent/detectionValue/getDetail',
        method: 'post',
        data
    })
}

/**批次检测获取保存的检测数据*/
export function getDefaultDataBack(data) {
  return request({
      url: '/icps/system/sign/intelligent/detectionValue/getDefaultDataBack',
      method: 'post',
      data
  })
}
/*获取库存仓 */
export function queryWarehouseByStation(data) {
  return request({
    url: '/icps/system/sign/intelligent/detectionValue/queryWarehouseByStation',
    method: 'post',
    data
  })
}
/*修改 */
export function updateResult(data) {
  return request({
    url: '/icps/system/sign/intelligent/detectionValue/updateResult',
    method: 'post',
    data
  })
}